import { useEffect, useState } from 'react'

const getCountdownReturnValue = (countdown) => {
  const days = Math.floor(countdown / (1000 * 60 * 60 * 24))
  const hours = Math.floor(
    (countdown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  )
  const minutes = Math.floor((countdown % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.floor((countdown % (1000 * 60)) / 1000)

  if (seconds < 0) {
    return null
  }

  return [
    countdownNumberWithZero(days),
    countdownNumberWithZero(hours),
    countdownNumberWithZero(minutes),
    countdownNumberWithZero(seconds),
  ]
}

const countdownNumberWithZero = (number, minLength = 2) =>
  String(number).padStart(minLength, '0')

const useCountdownTimer = (targetDate, callback) => {
  const countdownDate = new Date(targetDate).getTime()

  const [countdown, setCountdown] = useState(
    countdownDate - new Date().getTime()
  )

  useEffect(() => {
    const interval = setInterval(() => {
      const datahoje = countdownDate - new Date().getTime()
      setCountdown(datahoje)
      if (datahoje <= 0) {
        clearInterval(interval)

        if (callback) {
          callback()
        }
      }
    }, 1000)
  }, [countdownDate])

  return getCountdownReturnValue(countdown)
}

export default useCountdownTimer
